export let STREAM_STATES = /*#__PURE__*/function (STREAM_STATES) {
  STREAM_STATES["CREATED"] = "created";
  STREAM_STATES["STREAMING"] = "streaming";
  STREAM_STATES["PENDING_RECONNECT"] = "pending_reconnect";
  STREAM_STATES["CLOSED"] = "closed";
  return STREAM_STATES;
}({});
//# sourceMappingURL=stream-states.js.map